import { atom } from "recoil"
import { Key } from "../EnumKey"

const applierFilterAtom = atom({
  key: Key.APPLIERFILTER,
  default: [] as string[]
})

export default applierFilterAtom